export const name = 'componentsMeasures' as const
export const ComponentsMeasuresAPISymbol = Symbol('ComponentsMeasuresAPISymbol')
export const GroupMeasuresSymbol = Symbol('GroupMeasuresSymbol')
export const FiveGridLineMeasuresSymbol = Symbol('FiveGridLineMeasuresSymbol')
export const RegisterComponentsMeasureSymbol = Symbol('RegisterComponentMeasureSymbol')
export const PageChildMeasuresSymbol = Symbol('PageChildMeasuresSymbol')
export const MediaContainerChildMeasuresSymbol = Symbol('MediaContainerChildMeasuresSymbol')
